import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_LayerTab = _resolveComponent("LayerTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_FilterTab = _resolveComponent("FilterTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedLayer.label), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.saveLayer
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_TabView, {
      activeIndex: _ctx.activeIndex,
      "onUpdate:activeIndex": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeIndex = $event)),
      onTabChange: _ctx.onTabChange,
      class: "kn-overflow"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.layersManagement.layerTitle')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_LayerTab, {
              selectedLayer: _ctx.selectedLayer,
              allRoles: _ctx.allRoles,
              allCategories: _ctx.allCategories,
              onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["selectedLayer", "allRoles", "allCategories"])
          ]),
          _: 1
        }),
        (_ctx.layer.layerId)
          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.layersManagement.filterTitle')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_FilterTab, {
                  selectedLayer: _ctx.selectedLayer,
                  propFilters: _ctx.filters
                }, null, 8, ["selectedLayer", "propFilters"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["activeIndex", "onTabChange"]),
    _createVNode(_component_Toast, {
      position: "top-left",
      group: "tl"
    })
  ], 64))
}